import React from "react";
import { Constants } from "../../CommonMethhods/Constants";
import { numDifferentiationWithoutSymbol } from "../../CommonMethhods/CovertRupees";
import LoaderForSearch from "../Common/LoaderForSearch";

function ClientAumTable(props) {
  const checkResp = props.checkResp;
  const handleScroll = props.handleScroll;
  const scrollLoader = props.scrollLoader;

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper ">
        {checkResp && checkResp ? (
          <table className="table last-column">
            <thead>
              <tr>
                <th scope="col">{Constants.Client_Code}</th>
                <th scope="col" className="text-center">
                  {Constants.client_Name}
                </th>
                <th scope="col" className="text-center">
                  Franchisee Code
                </th>
                <th scope="col" className="text-center">
                  Sub Broker Code
                </th>
                <th scope="col" className="text-center">
                  Total AUM
                </th>
                <th scope="col" className="text-center">
                  Equity
                </th>
              </tr>
            </thead>
            <tbody onScroll={(e) => handleScroll(e)}>
              {checkResp &&
                checkResp.map((item, key) => {
                  return (
                    <tr key={key}>
                      <td>{item?.clientCode || "-"}</td>
                      <td>{item?.clientName || "-"}</td>
                      <td>{item?.rmCode || "-"}</td>
                      <td>{item?.subBrokerCode || "-"}</td>
                      <td>
                        {item?.aumAmt
                          ? numDifferentiationWithoutSymbol(item?.aumAmt)
                          : 0}
                      </td>
                      <td>
                        {item?.equity
                          ? numDifferentiationWithoutSymbol(item?.equity)
                          : 0}
                      </td>
                    </tr>
                  );
                })}
              {scrollLoader && (
                <div className="loader-center">
                  <LoaderForSearch />
                </div>
              )}
            </tbody>
          </table>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
export default ClientAumTable;
